import React from "react";
import "./style.css";

export const Middle = () => {
  return (
    <div className="middle">
      <div className="view-jobs">
        <div className="title">
          <p className="how-buildstart-helps">
            How Build Start helps you
            <br />
            find the Top Professionals
          </p>
        </div>

        <div className="overlap">
          <div className="element">
            <div className="overlap-group-2">
              <div className="overlap-2">
                <div className="ellipse" />

                <img className="icon-5" alt="Icon" src="/img/icon-1.png" />

                <div className="text-wrapper-4">01</div>
              </div>

              <img className="arrow" alt="Arrow" src="/img/arrow-4.png" />
            </div>

            <div className="text-wrapper-5">Research</div>

            <p className="look-for">
              Look for professionals in
              <br />
              your field of interest.
            </p>
          </div>

          <div className="element-2">
            <div className="overlap-3">
              <div className="overlap-4">
                <img className="vector" alt="Vector" src="/img/vector-1.svg" />

                <div className="ellipse-2" />

                <img className="icon-6" alt="Icon" src="/img/icon-2-1.png" />

                <div className="text-wrapper-6">02</div>

                <img className="arrow-2" alt="Arrow" src="/img/arrow-3.png" />

                <div className="element-3">
                  <div className="overlap-group-3">
                    <img
                      className="vector-2"
                      alt="Vector"
                      src="/img/vector-2.svg"
                    />

                    <div className="ellipse-3" />

                    <div className="text-wrapper-7">03</div>

                    <img
                      className="icon-7"
                      alt="Icon"
                      src="/img/icon-3-1.png"
                    />

                    <img className="arrow" alt="Arrow" src="/img/arrow-4.png" />
                  </div>

                  <div className="text-wrapper-8">Consultations</div>

                  <p className="schedule-meetings-or">
                    Schedule meetings or
                    <br />
                    consultations to assess
                    <br />
                    their fit for your needs.
                  </p>
                </div>
              </div>

              <div className="verify-their">
                Verify their qualifications,
                <br />
                certifications and
                <br />
                experience.
              </div>
            </div>

            <div className="text-wrapper-9">Check Credentials</div>
          </div>

          <div className="element-4">
            <div className="overlap-5">
              <div className="icon-wrapper">
                <img className="icon-8" alt="Icon" src="/img/icon-4-1.png" />
              </div>

              <div className="text-wrapper-10">04</div>

              <img className="arrow-3" alt="Arrow" src="/img/arrow-3.png" />
            </div>

            <div className="text-wrapper-11">Compare Candidates</div>

            <p className="evaluate-multiple">
              Evaluate multiple
              <br />
              professionals based on their
              <br />
              skills.
            </p>
          </div>

          <div className="element-5">
            <div className="overlap-6">
              <img className="vector-2" alt="Vector" src="/img/vector-4.svg" />

              <div className="ellipse-3" />

              <img className="icon-9" alt="Icon" src="/img/icon-5.png" />

              <div className="text-wrapper-7">05</div>

              <img className="arrow" alt="Arrow" src="/img/arrow-4.png" />
            </div>

            <div className="text-wrapper-12">Make a Decision</div>

            <p className="choose-the">
              Choose the professional
              <br />
              who best aligns with your
              <br />
              needs and values.
            </p>
          </div>

          <div className="element-6">
            <div className="overlap-7">
              <div className="ellipse-4" />

              <div className="ellipse-5" />

              <img className="icon-10" alt="Icon" src="/img/icon-6.png" />

              <div className="text-wrapper-13">06</div>
            </div>

            <div className="text-wrapper-14">Follow-Up</div>

            <div className="once-you-ve-selected">
              Once you&#39;ve selected
              <br />
              someone, maintain
              <br />
              communication.
            </div>
          </div>
        </div>
      </div>

      <div className="how-build-start">
        <div className="overlap-8">
          <img className="img-2" alt="Img" src="/img/img.png" />

          <div className="men">
            <div className="overlap-group-4">
              <div className="ellipse-6" />

              <img className="image-2" alt="Image" src="/img/image-9-1-1.png" />
            </div>
          </div>
        </div>

        <div className="overlap-9">
          <div className="line-5" />

          <div className="element-7">
            <div className="overlap-10">
              <div className="background" />

              <div className="ellipse-7" />

              <div className="ellipse-8" />

              <div className="text-wrapper-15">Guidance and Support</div>

              <p className="they-provide">
                They provide strategic advice and mentorship to
                <br />
                entrepreneurs, helping them navigate.
              </p>
            </div>

            <div className="line-6" />
          </div>

          <div className="element-8">
            <div className="overlap-10">
              <div className="background" />

              <div className="ellipse-7" />

              <div className="ellipse-8" />

              <div className="text-wrapper-16">Resource Access</div>

              <p className="build-start-connects">
                Build Start connects businesses with essential
                <br />
                resources, including funding opportunities.
              </p>
            </div>

            <div className="line-6" />
          </div>

          <div className="element-9">
            <div className="overlap-10">
              <div className="background" />

              <div className="ellipse-7" />

              <div className="ellipse-8" />

              <div className="text-wrapper-17">Workshops and Training</div>

              <p className="they-often-offer">
                They often offer educational programs focused on
                <br />
                skills development, covering areas.
              </p>
            </div>

            <div className="line-6" />
          </div>

          <div className="element-10">
            <div className="overlap-10">
              <div className="background" />

              <div className="ellipse-7" />

              <div className="ellipse-8" />

              <div className="text-wrapper-18">Community Building</div>

              <p className="build-start-fosters">
                Build Start fosters a supportive community where
                <br />
                entrepreneurs can share experiences.
              </p>
            </div>

            <div className="line-6" />
          </div>
        </div>

        <div className="how-build-start-wrapper">
          <div className="how-build-start-2">
            How Build Start
            <br />
            Helps Businesses
          </div>
        </div>
      </div>

      <div className="our-guides">
        <div className="div-wrapper">
          <div className="text-wrapper-19">Our Guides</div>
        </div>

        <p className="aenean-interdum">
          Aenean interdum porta nisi ut porta praesent aliquet dictum libero
          <br />
          sit amet imperdiet leo laoreet euismod ut libero ornare.
        </p>

        <div className="video">
          <div className="play-wrapper">
            <div className="play">
              <div className="overlap-group-5">
                <div className="ellipse-9" />

                <div className="ellipse-10" />

                <img
                  className="polygon"
                  alt="Polygon"
                  src="/img/polygon-1.svg"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="city">
          <div className="overlap-11">
            <div className="line-7" />

            <img className="image-3" alt="Image" src="/img/image-52-1.png" />
          </div>
        </div>
      </div>

      <div className="faq">
        <div className="title-2">
          <div className="text-wrapper-20">Frequently Asked Questions</div>

          <p className="text-wrapper-21">
            Questions to ask to determine a top building professional
          </p>
        </div>

        <div className="overlap-group-wrapper">
          <div className="overlap-group-6">
            <div className="vector-wrapper">
              <img className="vector-3" alt="Vector" src="/img/vector-9.svg" />
            </div>

            <p className="text-wrapper-22">
              Integer augue commodo tincidunt lectus?
            </p>
          </div>
        </div>

        <div className="overlap-wrapper">
          <div className="overlap-group-6">
            <div className="vector-wrapper">
              <img className="vector-3" alt="Vector" src="/img/vector-6.svg" />
            </div>

            <p className="text-wrapper-23">
              Oellentesque elit at nunc bibendum?
            </p>
          </div>
        </div>

        <div className="element-11">
          <div className="overlap-group-6">
            <div className="vector-wrapper">
              <img className="vector-3" alt="Vector" src="/img/vector-7.svg" />
            </div>

            <p className="text-wrapper-24">
              Aenean massa lacus sit amet condientum?
            </p>
          </div>
        </div>

        <div className="element-12">
          <div className="overlap-group-6">
            <div className="vector-wrapper">
              <img className="vector-3" alt="Vector" src="/img/vector-8.svg" />
            </div>

            <p className="text-wrapper-25">
              Pellentesque in faucibus urna eget?
            </p>
          </div>
        </div>

        <div className="element-13">
          <div className="overlap-group-6">
            <div className="vector-wrapper">
              <img className="vector-3" alt="Vector" src="/img/vector-9.svg" />
            </div>

            <p className="text-wrapper-26">
              Integer augue commodo tincidunt lectus?
            </p>
          </div>
        </div>

        <div className="element-14">
          <div className="overlap-12">
            <div className="background-2" />

            <div className="background-3" />

            <div className="ellipse-11" />

            <div className="minus" />

            <p className="text-wrapper-27">
              Oellentesque elit at nunc bibendum?
            </p>

            <p className="integer-feugiat">
              Integer feugiat laoreet sem quis fugiat quisque ante velit
              <br />
              facilisis ac lacus eget dictum commodo sapien. Morbi at
              <br />
              dolor vestibulum venenatis diam volutpat dolor quisque
              <br />
              nunc rutrum quis vestbulum efficitur nulla. Pellentesque
              <br />
              quis tincidunt maecenas bibendum.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
